import Swiper from 'swiper';
import { Navigation, Pagination, Manipulation } from 'swiper/modules';

export function initSwiper(el) {
  const id = el.id;
  if (!id || el.swiper) {
    return null;
  }

  // Manipulation provides appendSlide() so rails can be extended after init (e.g. the condensed
  // box async-loads the remaining Wunschgerät units); without it Swiper never registers the new
  // slides and the rail's sizing and dragging break.
  return new Swiper('#' + id, {
    modules: [Navigation, Pagination, Manipulation],
    slidesPerView: 'auto',
    spaceBetween: 16,
    grabCursor: true,
    simulateTouch: true,
    touchEventsTarget: 'container',
    observer: true,
    observeParents: true,
    loop: el.dataset.carouselLoop === 'true',
    centerInsufficientSlides: el.dataset.carouselCenterSparse === 'true',
    navigation: {
      nextEl: '.js_carousel__arrow--next[data-carousel="' + id + '"]',
      prevEl: '.js_carousel__arrow--prev[data-carousel="' + id + '"]',
    },
    pagination: {
      el: '.js_carousel__pagination[data-carousel="' + id + '"]',
      clickable: true,
    },
  });
}

function init() {
  document.querySelectorAll('.js_carousel__swiper').forEach(initSwiper);
}

init();
